"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = exports.CAPTION_PLACEHOLDER = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _classnames = _interopRequireDefault(require("classnames")),
    _vars = require("@devsta/ui-kit/dist/common/styles/vars"),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _Caption = _interopRequireDefault(require("../../Caption"));

require("../styles/_burnin-captions.scss");

var CAPTION_PLACEHOLDER = "Burn-in captions are stored permanently on the video file and play as part of your video \u2013 best compatibility, limited to one language.";
exports.CAPTION_PLACEHOLDER = CAPTION_PLACEHOLDER;

function onChangeBurnIn(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value;
  return function () {
    onChange({
      value: value
    });
  };
}

function renderPlaceHolder(isSmallView, placeholder) {
  return isSmallView ? null : _react["default"].createElement("p", null, placeholder || CAPTION_PLACEHOLDER);
}

function BurnInCaptions(_ref2) {
  var addons = _ref2.addons,
      onChangeAddon = _ref2.onChangeAddon,
      disabled = _ref2.disabled,
      size = _ref2.size,
      placeholder = _ref2.placeholder,
      onChange = onChangeAddon("BURN_IN_CAPTIONS"),
      value = (0, _lodash["default"])(addons, "BURN_IN_CAPTIONS"),
      hasBurnin = !!value || "" === value,
      isSmall = size.width < _vars.NUMERIC_MEDIA_SIZES.small;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("burnin-captions", {
      "burnin-captions--small": isSmall
    })
  }, _react["default"].createElement("div", {
    className: "burnin-captions__content"
  }, hasBurnin ? _react["default"].createElement(_Caption["default"], {
    label: "CAPTION",
    defaultLanguage: addons.BURN_IN_CAPTIONS || {
      value: null
    },
    onDelete: onChangeBurnIn({
      onChange: onChange,
      value: void 0
    }),
    onChange: onChange,
    selectedCaptions: [value],
    disabled: disabled,
    type: "BURN_IN_CAPTIONS"
  }) : renderPlaceHolder(isSmall, placeholder)), disabled ? null : _react["default"].createElement(_uiKit.Button, {
    small: !0,
    onClick: hasBurnin ? void 0 : onChangeBurnIn({
      onChange: onChange,
      value: ""
    }),
    disabled: hasBurnin
  }, "ADD BURN-IN"));
}

var _default = (0, _react.memo)(BurnInCaptions);

exports["default"] = _default;